module.exports = __webpack_public_path__ + "img/unsplash_oD4zvae0IDA.3aa5fdea.png";